import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { tableOptions } from "../../styles/tableStyle"
import { DialogWidget, SnackBarWidget } from "../../Widget";
import { Paper, Box, LinearProgress, Button, Typography, Tooltip } from "@mui/material"
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, TableSortLabel } from "@mui/material"
import TopAppBar from "../app/TopAppBar";
import { customStyles } from "../../styles/tableStyle"
import Project from "./Project";
import { AddCircle, Edit, Group, ParaglidingSharp } from "@mui/icons-material"
import ProjectUser from "./ProjectUser";
import AuthService from "../../service/AuthService";
const { commons, util } = require("../../commons")



export default function ManageProjects() {

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [projects, setProjects] = React.useState([]);
  const [project, setProject] = React.useState({})
  const [apiService, setApiService] = React.useState(false);
  const [dialogStatus, setDialogStatus] = React.useState(false);
  const [dialogType, setDialogType] = React.useState('');
  const [role, setRole] = React.useState('');

  useEffect(() => {
    getProjects()
  }, [])


  const getProjects = () => {
    let role = AuthService.getUserInfo().role
    setRole(role)
    let params = { op: "getProject" };
    if (role != "admin") params.users = [AuthService.getUserInfo()._id]
    setApiService(true)
    commons.getAPIRes(params, "POST", "project").then(apiRes => {
      setApiService(false)
      setProjects(apiRes.result)

    });
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleDialogClose = () => {
    setDialogStatus(false)
    setDialogType("")
  }

  const handleDialog = (e, key) => {
    setDialogStatus(true)
    setDialogType(key)
  };

  const handleProjectDialog = (e, key, item) => {
    setDialogStatus(true)
    setDialogType(key)
    setProject(item)
  };


  return (
    <Box spacing={2} style={{ width: '100%', flexDirection: 'column', display: 'flex' }}>
      <TopAppBar />
      <Typography variant="h6">Projects</Typography>
      {role == "user" ? false : <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ flex: 1 }}></div>
        <Tooltip title={"Create Project"} style={{ flex: 1 }}>
          <AddCircle onClick={(e) => handleDialog(e, "createProject")} />
        </Tooltip>
      </div>}

      <TableContainer component={Paper} sx={{ alignSelf: 'center', maxWidth: 650 }}>
        <Table size={"small"} aria-label="simple table">
          <TableHead style={tableOptions.headerStyle}>
            <TableRow>
              <TableCell style={{ textAlign: 'left' }}>Name</TableCell>
              <TableCell style={{ textAlign: 'center' }}>Client</TableCell>
              <TableCell style={{ textAlign: 'center' }}>Desc</TableCell>
              <TableCell style={{ textAlign: 'center' }}>Edit</TableCell>
              <TableCell style={{ textAlign: 'center' }}>Managers</TableCell>
              <TableCell style={{ textAlign: 'center' }}>Members</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {projects
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (<TableRow style={tableOptions.cellStyle}>
                  <TableCell style={{ textAlign: 'left' }}> {util.titleCase(row.name)} </TableCell>
                  <TableCell style={{ textAlign: 'center' }}> {row.client} </TableCell>
                  <TableCell style={{ textAlign: 'center' }}> {row.desc ? row.desc.toLowerCase() : ''} </TableCell>
                  <TableCell style={{ textAlign: 'center' }}>
                    <Tooltip title={"Edit " + util.titleCase(row.name)}>
                      <Edit onClick={(e) => handleProjectDialog(e, "updateProject", row)} />
                    </Tooltip>
                  </TableCell>
                  <TableCell style={{ textAlign: 'center' }}>
                    <Tooltip title={"View managers of " + util.titleCase(row.name)}>
                      <Group onClick={(e) => handleProjectDialog(e, "viewManagers", row)}
                        disabled={row.managers.includes(AuthService.getUserInfo()._id)} />
                    </Tooltip>
                  </TableCell> <TableCell style={{ textAlign: 'center' }}>
                    <Tooltip title={"View members of " + util.titleCase(row.name)}>
                      <Group onClick={(e) => handleProjectDialog(e, "viewMembers", row)}
                        disabled={row.members.includes(AuthService.getUserInfo()._id)} />
                    </Tooltip>
                  </TableCell>
                </TableRow>)
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        sx={{ alignSelf: 'center', maxWidth: 650 }}
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={projects.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />


      {dialogStatus && dialogType === "createProject" ?
        <DialogWidget
          maxWidth="sm"
          dialogTitle={"Create Project"}
          okTitle={"Submit"}
          negOk={false}
          dialogContent={<Project closeDialog={handleDialogClose} reloadPage={getProjects} />}
        /> : false}

      {dialogStatus && dialogType === "updateProject" ?
        <DialogWidget
          maxWidth="sm"
          dialogTitle={"Update Project"}
          okTitle={"Submit"}
          negOk={false}
          dialogContent={<Project closeDialog={handleDialogClose} project={project} reloadPage={getProjects} />}
        /> : false}
      {dialogStatus && dialogType === "viewManagers" ?
        <DialogWidget
          maxWidth="sm"
          dialogTitle={"Managers"}
          okTitle={"Submit"}
          negOk={false}
          closeDialog={handleDialogClose}
          dialogContent={<ProjectUser closeDialog={handleDialogClose} project={project} reloadPage={getProjects} type="managers" />}
        /> : false}


      {dialogStatus && dialogType === "viewMembers" ?
        <DialogWidget
          maxWidth="sm"
          dialogTitle={"Members"}
          okTitle={"Submit"}
          negOk={false}
          closeDialog={handleDialogClose}
          dialogContent={<ProjectUser closeDialog={handleDialogClose} project={project} reloadPage={getProjects} type="members" />}
        /> : false}
    </Box >
  );
}


